module.exports = __webpack_public_path__ + "static/media/banner-user-1.855b6400.png";